import React from "react";
import { Link } from "react-router";
import { connect } from "react-redux";
import { reduxForm, Field, SubmissionError, formValueSelector } from "redux-form";
import { toastr } from "react-redux-toastr";

import { LOGIN } from "../../actions/Constants";

import api from "../../api/apiUtil";
import TextIconField from "../../components/Fields/TextIconField";
import fieldNormalize from "../../components/Normalize/FieldNormalize";

import logo from "../../img/e-registro-logo.png";
import signInMicrosoft from "../../img/loginMS.png";
import backgroundLogin from "../../img/e-registro-login-bg-bright.jpg";
import * as Msal from "msal";
import ReCAPTCHA from "react-google-recaptcha";
import FieldValidation from "../../components/Validation/FieldValidation";
import queryString from "query-string";
import base64url from "base64url";
import SvgIcon from "react-icons-kit";
import { ic_fingerprint } from "react-icons-kit/md/ic_fingerprint";
import Cookies from "js-cookie";
import Modal from "react-bootstrap4-modal";
import FieldNormalize from "../../components/Normalize/FieldNormalize";
import Webcam from "react-webcam";
import { BeatLoader } from "react-spinners";
import { fileText } from "react-icons-kit/icomoon/fileText";

function b64stringToUint8Array(b64_string) {
  return Uint8Array.from(atob(b64_string), (c) => c.charCodeAt(0));
}

// takes a uint8 array and returns a b64-encoded string representation of it.
// Maybe a function for this wasn't needed since it does one thing (tm) but it
// looks quirky and I feel better having it tested as a unit.
function Uint8ArrayToB64String(array) {
  return btoa(String.fromCharCode.apply(null, new Uint8Array(array)));
}

function publicKeyCredentialToJSON(pubKeyCred) {
  const enc = new TextEncoder();
  if (pubKeyCred instanceof ArrayBuffer) {
    return Uint8ArrayToB64String(pubKeyCred);
  } else if (pubKeyCred instanceof Array) {
    return pubKeyCred.map(publicKeyCredentialToJSON);
  } else if (pubKeyCred instanceof Object) {
    const obj = {};
    for (let key in pubKeyCred) {
      obj[key] = publicKeyCredentialToJSON(pubKeyCred[key]);
    }
    return obj;
  } else return pubKeyCred;
}
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.formSubmit = this.formSubmit.bind(this);
    const values = queryString.parse(this.props.location.search);
    this.state = {
      captchaNotSelect: true,
      samlError: values.samlError,
      config: null,
      recuperouConfig: false,
      valueCaptcha: null,
      allowBiometric: false,
      recovery: values.recovery,
      show2fa: false,
      imgSrc: null,
      exibeCaptureFace: false,
      processandoFace: false,
    };
    this.webcamRef = React.createRef(null);
    if (process.env.REACT_APP_LOGIN_SAML) {
      fetch(process.env.REACT_APP_LOGIN_SAML)
        .then((url) => url.text())
        .then((url) => {
          this.setState({ samlLoginUrl: url });
        });
    }
    if (values.samlToken) {
      this.props.onLogin({ id_token: values.samlToken });
    }
  }

  componentDidMount() {
    Promise.resolve(api.Auth.ping()).then((r) => {
      Promise.resolve(api.Configuracao.getPorAtributo("template")).then((res) => {
        if (res) {
          this.setState({
            config: JSON.parse(res.valor),
          });
        }
        this.setState({ recuperouConfig: true });
      });
      if (this.state.recovery) {
        this.loginRecoveryKey(this.state.recovery);
      } else if (navigator.credentials && window.PublicKeyCredential) {
        window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then((a) => {
          console.log(a);
          var deviceUUID = Cookies.get("deviceUUID");
          this.setState({ allowBiometric: a && deviceUUID });
        });
      }
    });
    //api.Auth.ping(); // para buscar token CSRF
  }

  onChange(value) {
    this.setState({ captchaNotSelect: !this.state.captchaNotSelect, valueCaptcha: value });
  }

  render() {
    const { handleSubmit } = this.props;
    if (!this.state.recuperouConfig) {
      return null;
    }
    return (
      <div
        className="login-container login-background"
        style={{ backgroundImage: `url(${this.state.config && this.state.config.img_fundo_login ? "data:image/png;base64," + this.state.config.img_fundo_login : backgroundLogin})` }}
      >
        {/* <div className="splash"> <div className="color-line"></div><div className="splash-title"><h1>E-REGISTRO</h1><p>Registro de contrato de financiamento de veículos </p><div className="spinner"> <div className="rect1"></div> <div className="rect2"></div> <div className="rect3"></div> <div className="rect4"></div> <div className="rect5"></div> </div> </div> </div> */}
        <div className="color-line-ereg"></div>
        <div className="login-form">
          <div className="row">
            <div className="col-md-12">
              {/* <div className="text-center m-b-md">
                      {
                        process.env.REACT_APP_LOGO_URL ?
                        <img alt="" src={process.env.REACT_APP_LOGO_URL} className="mr-3 align-self-center mx-auto" style={{maxHeight: '30px'}}/>
                        :
                        <h3>E-REGISTRO</h3>
                      }

                        <small></small>
                    </div> */}
              <div className="hpanel">
                <div className="panel-body-round">
                  <div className="login-img-container">
                    <img src={this.state.config && this.state.config.logo_sistema ? `data:image/jpeg;base64,${this.state.config.logo_sistema}` : logo} />
                  </div>
                  <form id="loginForm" onSubmit={handleSubmit(this.formSubmit)}>
                    <Field
                      required
                      validate={[FieldValidation.required]}
                      name="username"
                      label="Usuário"
                      component={TextIconField}
                      normalize={fieldNormalize.CPF}
                      icon="fa-user"
                      type="text"
                      placeholder="000.000.000-00"
                      title="Digite seu CPF cadastrado no sistema"
                    />
                    <Field
                      required
                      validate={[FieldValidation.required]}
                      name="password"
                      label="Senha"
                      component={TextIconField}
                      icon="fa-key"
                      type="password"
                      placeholder="******"
                      title="Digite sua senha de acesso"
                    />

                    <ReCAPTCHA
                      className="btn-reCaptcha"
                      sitekey="6LfzBOAUAAAAAP_xf_UoEARv84VecG1-14RZ3BtB"
                      onChange={this.onChange.bind(this)}
                      onExpired={() => this.setState({ captchaNotSelect: true })}
                    />

                    <button ref="btn" type="submit" disabled={this.state.captchaNotSelect} className="btn btn-alternative btn-login btn-block" to="/secure">
                      ENTRAR
                    </button>

                    <Link to="/forgot" className="btn btn-link-blue btn-block">
                      Esqueceu a senha?
                    </Link>
                  </form>
                  {process.env.REACT_APP_LOGIN_MS || process.env.REACT_APP_LOGIN_SAML ? <div className="border-top" /> : ""}
                  {process.env.REACT_APP_LOGIN_MS ? (
                    <form id="loginMSForm">
                      <button type="submit" className="btn btn-ms" to="/secure" onClick={handleSubmit(this.loginMicrosoft.bind(this))}>
                        <img src={signInMicrosoft} />
                      </button>
                    </form>
                  ) : (
                    ""
                  )}
                  {process.env.REACT_APP_LOGIN_SAML ? (
                    <form id="loginSAMLForm">
                      <a className="btn btn-ms" href={this.state.samlLoginUrl}>
                        <img src={signInMicrosoft} />
                      </a>
                    </form>
                  ) : (
                    ""
                  )}
                  {this.state.allowBiometric ? (
                    <div className="border-top">
                      <br />
                      <button className="btn btn-alternative btn-login btn-block" onClick={this.loginBiometric.bind(this)}>
                        <SvgIcon size={20} icon={ic_fingerprint} /> ENTRAR COM BIOMETRIA
                      </button>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="border-top">
                    <br />
                    {/* <button className="btn btn-alternative btn-login btn-block" onClick={() => this.setState({ exibeCaptureFace: true })} disabled={!this.props.username}>
                      <SvgIcon size={20} icon={ic_fingerprint} /> ENTRAR COM BIOMETRIA FACIAL
                    </button> */}
                    <Link to={"https://homicp.e-registro.net.br/api/loginICP"} target="_top" className="btn btn-alternative btn-login btn-block">
                      <SvgIcon size={20} icon={fileText} /> ENTRAR COM CERTIFICADO ICP-Brasil
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            /* <div className="row">
              {
                process.env.REACT_APP_LOGO_URL ?
                <div className="col-md-12 text-center">
                    Registro de contrato de financiamento de veículos
                </div>
                :
                <div className="col-md-12 text-center">
                    <strong>E-REGISTRO</strong> - Registro de contrato de financiamento de veículos<br/>  &copy; 2018 Alias
                </div>
              }

            </div> */
            this.state.samlError ? toastr.warning("Atenção", this.state.samlError) : ""
          }
        </div>
        <Modal visible={this.state.exibeCaptureFace} dialogClassName="modal-max-width-700">
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-body">
                  <form className="form-horizontal">
                    {this.state.processandoFace ? (
                      <>
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <h3>Aguarde, processando...</h3>
                            <BeatLoader size={20} color="#36d7b7" />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="row">
                          <div className="col-md-12">
                            {!this.state.imgSrc && this.state.exibeCaptureFace && <Webcam audio={false} width={650} height={450} ref={this.webcamRef} screenshotFormat="image/jpeg" />}
                            {this.state.imgSrc && (
                              <>
                                <img src={this.state.imgSrc} />
                                <p></p>
                              </>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="text-right">
                              <button type="button" className="btn btn-secondary" onClick={this.cancelCaptureFace}>
                                Cancelar
                              </button>
                              {!this.state.imgSrc && (
                                <button type="button" className="btn btn-info" onClick={this.capture.bind(this)}>
                                  Capturar foto
                                </button>
                              )}
                              {this.state.imgSrc && (
                                <>
                                  &nbsp;
                                  <button type="button" className="btn btn-success" onClick={this.loginBiometricFace.bind(this)}>
                                    Confirmar
                                  </button>
                                  &nbsp;
                                  <button type="button" className="btn btn-warning" onClick={() => this.setState({ imgSrc: null })}>
                                    Tirar outra foto
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal visible={this.state.show2fa}>
          <div className="row">
            <div className="col-md-12">
              <div className="hpanel">
                <div className="panel-body">
                  <form className="form-horizontal" onSubmit={handleSubmit(this.formSubmit2fa.bind(this))}>
                    <div className="row">
                      <div className="col-md-12">
                        <Field
                          name="uuid2fa"
                          label="Digite o código de acesso recebido por email"
                          component={TextIconField}
                          icon="fa-key"
                          type="text"
                          required
                          validate={[FieldValidation.nospace]}
                          normalize={FieldNormalize.NUMBER}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="text-right">
                          <button type="button" className="btn btn-secondary" onClick={this.cancel2fa}>
                            Cancelar
                          </button>
                          <button type="submit" className="btn btn-primary">
                            Confirmar
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }

  cancel2fa = () => {
    this.setState({ show2fa: !this.state.show2fa, captchaNotSelect: true });
    grecaptcha.reset();
  };

  formSubmit2fa(values) {
    const errors = {};
    if (!values.uuid2fa || values.uuid2fa.length === 0 || !values.uuid2fa.trim()) {
      errors.uuid2fa = "Campo obrigatório";
    }
    if (errors && !_.isEmpty(errors)) {
      throw new SubmissionError(errors);
    }
    var param = {
      cpf: values.username.replace(/[^\d]/g, ""),
      uuid2fa: values.uuid2fa,
    };
    Promise.resolve(api.Auth.login2fa(param))
      .then((auth) => {
        this.props.onLogin(auth);
      })
      .catch(function (resp) {
        toastr.warning("Atenção", resp);
      });
  }

  formSubmit(values) {
    var btn = this.refs.btn;
    btn.setAttribute("disabled", "disabled");
    Promise.resolve(api.Auth.login(values.username.replace(/[^\d]/g, ""), values.password, this.state.valueCaptcha))
      .then((auth) => {
        if (auth.possui2fa) {
          toastr.success("Sucesso", "Código de acesso enviado para o email cadastrado.");
          this.setState({ show2fa: true });
        } else {
          this.props.onLogin(auth);
        }
        btn.removeAttribute("disabled");
      })
      .catch(function (resp) {
        btn.removeAttribute("disabled");
        toastr.warning("Atenção", resp);
      });
  }

  loginMicrosoft(values) {
    var msalConfig = {
      auth: {
        clientId: "ac559fd8-8b66-47de-8018-f15a2302a93b",
        authority: "https://login.microsoftonline.com/common",
        redirectURI: window.location.origin,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
      },
    };

    var myMSALObj = new Msal.UserAgentApplication(msalConfig);
    var requestObj = {
      scopes: ["user.read"],
    };
    var p = this.props;
    myMSALObj
      .loginPopup(requestObj)
      .then(function (loginResponse) {
        //Login Success callback code here
        myMSALObj.acquireTokenSilent(requestObj).then(function (tokenResponse) {
          Promise.resolve(api.Auth.loginMicrosoft(tokenResponse.accessToken))
            .then((auth) => {
              p.onLogin(auth);
            })
            .catch(function (resp) {
              toastr.warning("Atenção", resp);
            });
        });
      })
      .catch(function (error) {});
  }

  loginBiometric(values) {
    var p = this.props;
    Promise.resolve(api.Profile.getChallengePublicKey())
      .then((ret) => {
        console.log(ret);
        navigator.credentials
          .get({
            publicKey: {
              challenge: b64stringToUint8Array(base64url(ret.challenge)),
              rpId: document.domain,
              allowCredentials: [
                {
                  type: "public-key",
                  id: b64stringToUint8Array(ret.publicKey),
                },
              ],
              userVerification: "discouraged",
              timeout: 90000,
            },
          })
          .then((assertionObj) => {
            console.log(assertionObj);
            const webAuthnAttestation = publicKeyCredentialToJSON(assertionObj);
            console.log(webAuthnAttestation);
            Promise.resolve(api.Profile.verifySignature(webAuthnAttestation))
              .then((auth) => {
                p.onLogin(auth);
              })
              .catch(function (resp) {
                toastr.warning("Atenção", resp);
              });
          });
      })
      .catch(function (resp) {
        toastr.warning("Atenção", "Biometria não cadastrada para este dispositivo");
      });
  }

  capture() {
    const imageSrc = this.webcamRef.current.getScreenshot();
    this.setState({ imgSrc: imageSrc });
  }

  cancelCaptureFace = () => {
    this.setState({ imgSrc: null, exibeCaptureFace: false, processandoFace: false });
  };

  loginBiometricFace() {
    var props = this.props;
    this.setState({ processandoFace: true });
    var param = {
      cpf: props.username.replace(/[^\d]/g, ""),
      imagem: this.state.imgSrc.split("base64,")[1],
    };
    Promise.resolve(api.Users.loginBiometricFace(param))
      .then((ret) => {
        this.cancelCaptureFace();
        this.props.onLogin(ret);
      })
      .catch(
        function (resp) {
          this.cancelCaptureFace();
          if (resp.message === "Unauthorized" || resp.message === "jwt expired") {
            api.Auth.logout();
            props.onLogout();
          } else if (resp == "Biometria não validada.") {
            toastr.warning("Atenção", "Biometria não validada.");
          } else if (resp.response && resp.response.text) {
            toastr.warning("Atenção", JSON.parse(resp.response.text).message);
          } else {
            toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
          }
        }.bind(this)
      );
  }

  loginRecoveryKey(value) {
    Promise.resolve(api.Auth.loginRecovery(value))
      .then((auth) => {
        this.props.onLogin(auth);
      })
      .catch(function (resp) {
        toastr.warning("Atenção", resp);
      });
  }

  // formSubmit(values) {
  //   var btn = this.refs.btn;
  //   btn.setAttribute("disabled", "disabled");
  //   Promise.resolve(api.Auth.login(values.username.replace(/[^\d]/g, ""), values.password, this.state.valueCaptcha))
  //     .then((auth) => {
  //       this.props.onLogin(auth);
  //       btn.removeAttribute("disabled");
  //     })
  //     .catch(function (resp) {
  //       btn.removeAttribute("disabled");
  //       toastr.warning("Atenção", resp);
  //     });
  // }
}

const selector = formValueSelector("LoginForm");
const mapStateToProps = (state) => ({
  username: selector(state, "username"),
});

const mapDispatchToProps = (dispatch) => ({
  onLogin: (payload) => dispatch({ type: LOGIN, payload }),
});

const form = reduxForm({
  form: "LoginForm",
});

export default connect(mapStateToProps, mapDispatchToProps)(form(Login));
